import * as CoreFns from './CoreFns';

export function fillUpEntityRecursively(struct){
    if (struct.t === 'tuple'){
      if (struct.v[0].t === 'list'){
        var list = struct.v[0].v;
        var msg = {};
        list.forEach((aSet, index)=>{
          var entityType = aSet.v[0].v;
          var entityPieces = '';
          if (entityType === 'x'){
            entityPieces = parseList(aSet.v[1]);
          }else{
            entityPieces = fillUpEntityRecursively(aSet.v[1]);
          }
          msg[entityType] = entityPieces;
        })
        return msg;
      }else{
        console.log(struct);
      }
    }else if (struct.t === 'number' || struct.t === 'binary'){
      return struct.v;
    }else if (struct.t === 'list'){
      return struct.v.map((aP, index)=>{
        return fillUpEntityRecursively(aP);
      })
    }else if (struct.t === 'atom'){
      if (struct.v === 'true'){
        return true;
      }else if (struct.v === 'false'){
        return false;
      }else{
        console.log(struct);
      }
    }else if (struct.t === 'number'){
    }else{
      console.log(struct);
    }
  }

function parseList(list){
  return list.v.map((aE, index)=>{
    return parseElement(aE);
  })
}


export function parseElement(tuple){
  if (tuple.t === 'tuple'){
    var zeroth = tuple.v[0].v;
    if (zeroth === 't'){
      var styles = tuple.v[2].v;
      var s = {};
      styles.forEach((aStyle, index)=>{
        var title = aStyle.v[0].v;
        var value = aStyle.v[1].v;
        s[title] = value;
      })
      var textBit = tuple.v[1].v;
      if (tuple.v[1].t === 'list'){
        textBit = '';
      }
      return {t:'t',v:textBit, s};
    }else if (zeroth === 'tb'){
      var styles1 = tuple.v[2].v;
      var s1 = {};
      styles1.forEach((aStyle, index)=>{
        var title = aStyle.v[0].v;
        var value = aStyle.v[1].v;
        s1[title] = value;
      })
      var textBit1 = tuple.v[1].v.map((aV, index)=>{
          return {u:aV.v};
        })
      return {t:'tb',v:textBit1, s:s1};
    }else if (tuple.v[0].v === 'a'){
      return {t:'a',n:tuple.v[1].v,i:tuple.v[2].v};
    }else if (tuple.v[0].v === 'br'){
      return {t:'br'};
    }else if (tuple.v[0].v === 'h'){
      return {t:'h',n:tuple.v[1].v};

    }else if (zeroth === 'g'){  //start of fn.
      var is = {t:zeroth,v:tuple.v[1].v}
      if (tuple.v[2].t === 'binary'){
        is.ti = tuple.v[2].v;
      }
      return is;
    }else if (zeroth === 'u'){ //this is the start of the formula.
      return {t:'u'};
    }else if (zeroth === 'eV' || zeroth === 'eS' || CoreFns.withP(zeroth) ){ 
      var p = [];
      var point = 2;
      if (zeroth === 'eV'){
        point = 3;
      }else if (zeroth === 'eS'){
        point = 5;
      }
      if (tuple.v[point]){
        p = tuple.v[point].v.map((aP, index)=>{
          if (aP.t === 'tuple'){
            if (aP.v[0].v === 'oP'){
              return {t:'oP',n:aP.v[1].v};
            }else{
              console.warn(tuple);
            }
          }else if (aP.t === 'atom'){
            return {t:aP.v}
          }else{
            console.warn(tuple);
          }
          return null;
        })

      }
      if (zeroth === 'eS'){
        var a = tuple.v[4].v.map((aV, index)=>{
          return aV.v;
        })
        var n1 = tuple.v[3].v;
        if (n1 === 'false'){
          n1 = '';
        }
        return {t:'eS',s:tuple.v[1].v,i:tuple.v[2].v,n:n1, a, p};
      }else if (zeroth === 'eV'){
        return {t:zeroth,s:tuple.v[1].v,i:tuple.v[2].v,p};      
      }else{
        var v = tuple.v[1].v;
        if (zeroth === 'aC'){
          v = {k:tuple.v[1].v[0].v, s:tuple.v[1].v[1].v};
        }else if (zeroth === 'gV' || zeroth === 'inP'){
          v = v.map((aV, index)=>{return aV.v});
        }
        var x = {t:zeroth,v,p};
        if (zeroth === 'm'){
          x.ta = tuple.v[3].v;
        }
        return x;        
      }
    }else if (zeroth === 'pa' || zeroth === 'al'){
      var v1 = tuple.v[1].v.map((aV, index)=>{return aV.v});
      return {t:zeroth, v:v1}
    }else if (zeroth === 'map'){ 
      return {t:'f',v:58,m0:tuple.v[1].v};
    }else if (zeroth === 'sort'){ 
      return {t:'f',v:24,m0:tuple.v[1].v,m1:tuple.v[2].v};
    }else if (zeroth === 'fil'){ 
      return {t:'f',v:59,m0:tuple.v[1].v};
    }else if (zeroth === 'red'){ 
      return {t:'f',v:71,m0:tuple.v[1].v,m1:tuple.v[2].v};

    }else if (zeroth === 'pl' ){ 
      return {t:zeroth,v:tuple.v[1].v,p:tuple.v[2].v,ti:tuple.v[3].v};
    }else if (zeroth === 'dt'){
      return {t:zeroth,v:+tuple.v[1].v};
    }else if (CoreFns.directV(zeroth)){ 
      return {t:zeroth,v:tuple.v[1].v};
    }else if (zeroth === 'footer'){
      return {t:zeroth};
    }else{
      console.log(zeroth);
      console.warn(tuple);
      // return {t:'br'};
    }
  } 
}
